import React from 'react';
import { cn } from '@/lib/utils';

const GlassInput = React.forwardRef(({ 
  className,
  label,
  error,
  type = 'text',
  ...props 
}, ref) => {
  return (
    <div className="w-full">
      {label && (
        <label 
          className="text-overline block mb-2 transition-colors duration-180"
          style={{ color: 'var(--color-text-muted)' }}
        >
          {label}
        </label>
      )}
      <input
        ref={ref}
        type={type}
        className={cn(
          'w-full h-[52px] px-5',
          'rounded-[var(--radius-lg)]',
          'glass-subtle',
          'font-["Inter"] text-[15px]',
          'transition-all duration-180',
          'focus:outline-none focus:ring-4 focus:ring-[rgba(61,90,128,0.08)]',
          'focus:bg-[rgba(255,255,255,0.65)]',
          'placeholder:text-[var(--color-text-muted)]',
          error && 'border-[var(--color-critical)]',
          className
        )}
        style={{
          color: 'var(--color-text-primary)',
          borderColor: error ? 'var(--color-critical)' : 'rgba(255, 255, 255, 0.60)'
        }}
        {...props}
      />
      {error && (
        <p className="mt-2 text-xs font-medium" style={{ color: 'var(--color-critical)' }}>
          {error}
        </p>
      )}
    </div>
  );
});

GlassInput.displayName = 'GlassInput';

export { GlassInput };